export default {
  getKnowledgesDataByType: "BackEnd/getKnowledgesDataByType",
  getKnowledgesDetails: "BackEnd/getKnowledgesDetails",
  setKnowledgesData: "BackEnd/setKnowledgesData",
  updateKnowledgesData: "BackEnd/updateKnowledgesData",
  deleteKnowledgesData: "BackEnd/deleteKnowledgesData",
  updateKnowledgesOrders: "BackEnd/updateKnowledgesOrders",
  getKnowledgesCountsRecordMemberCountsByKid:
    "BackEnd/getKnowledgesCountsRecordMemberCountsByKid",
  setKnowledgesLikes: "BackEnd/setKnowledgesLikes",
  deleteKnowledgesLikes: "BackEnd/deleteKnowledgesLikes",
};
